exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".playlist-controls[data-v-79618070] {\n  cursor: pointer;\n  transition: 0.4s linear;\n}\n.playlist-controls.playlist-control-on[data-v-79618070] {\n  color: #4099FF;\n}", ""]);

// exports
